export class OpenApiError extends Error {
  status: number;
  errorKey: string;
  constructor({ message, status, errorKey }: { message: string; status: number; errorKey: string }) {
    super(message);
    this.name = 'OpenApiError';
    this.message = message;
    this.status = status;
    this.errorKey = errorKey;
  }
}

export const is401Error = (error: unknown): error is OpenApiError => {
  return error instanceof OpenApiError && error.status === 401;
};

export const is404Error = (error: unknown): error is OpenApiError => {
  return error instanceof OpenApiError && error.status === 404;
};

export const is500Error = (error: unknown): error is OpenApiError => {
  return error instanceof OpenApiError && error.status === 500;
};

export const is403Error = (error: unknown): error is OpenApiError => {
  return error instanceof OpenApiError && error.status === 403;
};
